import { useForm } from '@mantine/form';
import { Button, Group, TextInput, Stack, Modal } from '@mantine/core';

export interface CreatePartnerAccountantForm {
  name: string;
  email: string;
}

interface CreatePartnerAccountantModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: ({
    formValues,
  }: {
    formValues: CreatePartnerAccountantForm;
  }) => void;
  isPending: boolean;
}

export default function CreatePartnerAccountantModal({
  opened,
  onClose,
  onConfirm,
  isPending,
}: CreatePartnerAccountantModalProps) {
  const form = useForm<CreatePartnerAccountantForm>({
    mode: 'uncontrolled',
    initialValues: { name: '', email: '' },
    validate: {
      name: (value) => (value ? null : ' '),
      email: (value) => (value ? null : ' '),
    },
  });

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="新增會計人員"
      centered
      styles={{ title: { fontWeight: 700, fontSize: 16 } }}
    >
      <Stack>
        <form
          onSubmit={form.onSubmit((values: CreatePartnerAccountantForm) =>
            onConfirm({ formValues: values }),
          )}
        >
          <TextInput
            withAsterisk
            label="人員名稱"
            placeholder="請輸入人員名稱"
            key={form.key('name')}
            {...form.getInputProps('name')}
          />
          <TextInput
            mt="md"
            withAsterisk
            label="Email"
            placeholder="請輸入Email"
            key={form.key('email')}
            {...form.getInputProps('email')}
          />
          <Group justify="flex-end" mt="md">
            <Button type="button" onClick={onClose} variant="outline" fw={400}>
              取消
            </Button>
            <Button type="submit" loading={isPending} fw={400}>
              新增
            </Button>
          </Group>
        </form>
      </Stack>
    </Modal>
  );
}
